import { NgModule } from '@angular/core';
import { AssessmentGraphDataComponent } from './assessment-graph-data/assessment-graph-data.component';
import { RelationGraphComponent } from './relation-graph/relation-graph.component';

@NgModule({
  declarations: [AssessmentGraphDataComponent, RelationGraphComponent],
  imports: [],
  exports: [AssessmentGraphDataComponent, RelationGraphComponent],
})
export class GraphModule {}
